import { ISystemConfig } from '@/features/system-configs/systemConfigSlice'
import IApiResponse from '@/types/api-response';
import IList from '@/types/list-result';
import axios from '@/utils/axios-instance'

export const listConfigs = async (params?: any): Promise<IApiResponse<IList<ISystemConfig>>> => {
	const { data } = await axios.get<IApiResponse<IList<ISystemConfig>>>('/api/system-config', { params })
	return data
}

export const updateConfig = async (params?: any): Promise<IApiResponse<null | undefined>> => {
	const { data } = await axios.put<IApiResponse<null | undefined>>('/api/system-config', params)
	return data
}

export const removeConfig = async (params?: any): Promise<IApiResponse<null | undefined>> => {
	const { data } = await axios.delete<IApiResponse<null | undefined>>('/api/system-config', { params })
	return data
}

export const addConfig = async (params?: any): Promise<IApiResponse<null | undefined>> => {
	const { data } = await axios.post<IApiResponse<null | undefined>>('/api/system-config', params)
	return data
}
